import * as Types from '../constants/Types';
import { ProfileType } from '../models/PayAtHotel';

const initialState = {
    isFetching: false,
    payAtHotel: {},
    profileTypes: new ProfileType()
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.GET_PAY_AT_HOTEL_ACTION:
            return { ...state, isFetching: true };
        case Types.GET_PAY_AT_HOTEL_SUCCESS:
            return {
                ...state,
                payAtHotel: action.payAtHotel,
                isFetching: false
            };
        case Types.PAY_AT_HOTEL_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.PAY_AT_HOTEL_UPDATE_SUCCESS:
            return { ...state, isFetching: false };
        case Types.GET_PROFILE_TYPE_ACTION:
            return { ...state, isFetching: true };
        case Types.GET_PROFILE_TYPE_SUCCESS:
            return {
                ...state,
                profileTypes: action.profileTypes,
                isFetching: false
            };
        case Types.PAY_AT_HOTEL_FAIL: 
            return initialState
        default: 
            return state
    }
}